import { IYoutubeScrapeResponseItem } from "@shared/lib/types/influencer";

export type YoutubeSearchStats = {
  videoCount: number;
  creatorCount: number;
  shortsCount: number;
  longFormCount: number;
  avgViews: number;
  avgEngagementRate: number;
};

function isShort(item: IYoutubeScrapeResponseItem): boolean {
  const type = item.videoType?.toLowerCase() ?? "";
  if (type.includes("short")) {
    return true;
  }
  if (type.includes("long") || type.includes("video")) {
    return false;
  }
  return item.durationSeconds > 0 && item.durationSeconds <= 60;
}

function toPercent(rate: number): number {
  return rate <= 1 ? rate * 100 : rate;
}

export function getYoutubeSearchStats(
  items: IYoutubeScrapeResponseItem[]
): YoutubeSearchStats {
  const videoCount = items.length;
  const creatorCount = new Set(
    items.map((item) => item.channelId || item.channelUrl)
  ).size;
  const shortsCount = items.filter(isShort).length;
  const viewsTotal = items.reduce((sum, item) => sum + (item.views || 0), 0);
  const engagementTotal = items.reduce(
    (sum, item) => sum + toPercent(item.engagementRate || 0),
    0
  );

  return {
    videoCount,
    creatorCount,
    shortsCount,
    longFormCount: videoCount - shortsCount,
    avgViews: videoCount ? viewsTotal / videoCount : 0,
    avgEngagementRate: videoCount ? engagementTotal / videoCount : 0,
  };
}
